<div class="auth-flex-columns">
  <div class="auth-inner-wrapper min-height">
    <img (click)="closeDialog()" class="close-icon" src="./../../../../assets/images/icons/close.svg" alt="close-icon">
    <div class="form-block">
      <div class="heading">
        <h1 class="page-title">Forgot password?</h1>
        <p class="auth-page-description">You will receive an email with instruction on how to retrieve your password.
        </p>
      </div>
      <form [formGroup]="forgotPasswordForm">

        <app-inline-input-control [type]="'email'" [control]="forgotPasswordForm.controls[ForgotPasswordFields.Email]"
          [label]="'Email address:'" [name]="ForgotPasswordFields.Email"></app-inline-input-control>

        <button (click)="resetPassword()" [disabled]="!forgotPasswordForm.valid" class="c-button secondary w-100"
          pButton pRipple>
          <span>Reset password</span>
          <img class="btn-icon ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="sign-in">
        </button>
        <div class="extra-links">
          <p class="line">
            <span>Remembered password ? <a (click)="openLoginDialog()">Sign in</a></span>
          </p>
        </div>
      </form>
    </div>
  </div>
  <div class="banner-container">
    <app-current-banner [minWidth]="380" [authDialogStyles]="true"></app-current-banner>
  </div>
</div>
